import script from "./StorePrefs.vue?vue&type=script&setup=true&lang=js"
export * from "./StorePrefs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import DomainsSection from "@/components/storefront/DomainsSection.vue";
import ImageUploaderNeue from "@/components/neue/ImageUploaderNeue.vue";
import InputField from "@/components/neue/InputField.vue";
import NeueLoading from "@/components/neue/NeueLoading.vue";
import SaveBar from "@/components/SaveBar.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
import SettingsSection from "@/components/neue/SettingsSection.vue";
script.components = Object.assign({}, { DomainsSection, ImageUploaderNeue, InputField, NeueLoading, SaveBar, SecondaryNav, SecondaryTop, SettingsSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { DomainsSection, ImageUploaderNeue, InputField, NeueLoading, SaveBar, SecondaryNav, SecondaryTop, SettingsSection }, script.__o.components);}